import type { MachineSupaDto } from "@strtmn/sds/types"
import { I18n } from "aws-amplify/utils"
import { useNavigate, useSearchParams } from "react-router-dom"
import { filterMachines, sortMachines } from "../../api/MachinesApi"

interface MachineTableProps {
  machines: MachineSupaDto[]
}

export default function MachineTable({ machines }: MachineTableProps) {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  function redirectToEditMachine(machine: MachineSupaDto) {
    navigate(`../machines/${machine.id}`)
  }

  if (machines.length === 0) {
    return <div className="search-result-info">{I18n.get("Keine Daten.")}</div>
  }

  const filter = searchParams.get("filter")?.toLocaleLowerCase()
  const machinesFiltered = filterMachines(machines, filter)
  const machinesSorted = sortMachines(machinesFiltered)

  return (
    <table className="admin-table w-full">
      <thead>
        <tr className="bg-slate-300">
          <th>{I18n.get("Name")}</th>
          <th>{I18n.get("M.Typ")}</th>
          <th>{I18n.get("VIN")}</th>
          {/* <th>{I18n.get("Anz. Betr.")}</th> */}
        </tr>
      </thead>
      <tbody>
        {machinesSorted.map((machine, idx) => (
          <tr
            key={machine.id}
            className={
              "cursor-pointer " +
              (idx % 2 === 0 ? "bg-slate-100" : "bg-slate-200")
            }
            onClick={() => redirectToEditMachine(machine)}
          >
            <td className="pl-2">{machine.name}</td>
            <td>{machine.machine_type}</td>
            <td>{machine.serial_number}</td>
            {/* <td>{(machine.MachinesOrganizations ?? []).length}</td> */}
          </tr>
        ))}
      </tbody>
    </table>
  )
}
